import React, { useState, useEffect } from 'react';
import { useIntl, getLocale } from 'umi';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import { IDomEditor, IEditorConfig, IToolbarConfig, i18nChangeLanguage } from '@wangeditor/editor';
import { Modal, Button } from 'tea-component';
import '@wangeditor/editor/dist/css/style.css';

const EditModal = (props: any) => {
  const { closeModal, handelCancel: propsHandleCancel, isVisible, data, handleSubmit: propsHandelSubmit, title = '',customPaste, loading=false,  ...resetProps } = props || {};

  const { formatMessage } = useIntl();
  const languageType = getLocale() === 'en-US' ? 'en' : 'zh-CN';
  i18nChangeLanguage(languageType);

  // editor 实例
  const [editor, setEditor] = useState<IDomEditor | null>(null); // TS 语法

  // 编辑器内容
  const [html, setHtml] = useState(data || '');

  // 工具栏配置
  const toolbarConfig: Partial<IToolbarConfig> = {
    toolbarKeys: [
      'bold',
      'underline',
      // 'through',
      'fontSize',
      'color',
      'bulletedList',
      'numberedList',
      {
        key: 'group-justify-style',
        title: 'justify',
        iconSvg: `<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>`,
        menuKeys: [
          'justifyLeft',
          'justifyRight',
          'justifyCenter',
          'justifyJustify',
        ],
      },
      'clearStyle',
      'undo',
      'redo',
    ],
    excludeKeys: [],
  };

  // 编辑器配置
  const editorConfig: Partial<IEditorConfig> = {
    placeholder: `${formatMessage({ id: 'dbh_studio_funcom_edit_modal_placeholder' })}...`,
    MENU_CONF: {
      fontSize: {
        fontSizeList: ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px'],
      },
    },
    ...(customPaste ? { customPaste } : {})
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor) {
        editor.destroy();
        setEditor(null);
      }
    };
  }, [editor]);

  useEffect(() => {
    setHtml(data || '');
  }, [data]);

  const handleEditorChange = (editor: IDomEditor) => {
    const text = editor.getText();
    let resultVal = editor.getHtml();
    // editor.getHtml()在删除完的时候返回的是<p><br></p>，所以用text来判断
    if (text.trim() === '') {
      resultVal =  '';
    }
    setHtml(resultVal);
  };

  // 提交
  const handleSubmit = () => {
    // 处理提交逻辑
    propsHandelSubmit?.(html);
  };

  // 取消
  const handelCancel = () => {
    propsHandleCancel?.();
    // 恢复初始值
    setHtml(data);
  };

  // 编辑器挂载
  const handleEditorCreated = (editorInstance: IDomEditor) => {
    setEditor(editorInstance);
  };

  return (
    <>
      <Modal
        visible={isVisible}
        size={1000}
        caption={title || formatMessage({ id: 'Edit' })}
        onClose={() => {
          closeModal();
          // 恢复初始值
          setHtml(data);
        }}
        {...(resetProps || {})}
      >
        <Modal.Body>
          <div style={{ border: '1px solid #ddd', zIndex: 100, position: 'relative' }}>
            <Toolbar
              editor={editor}
              defaultConfig={toolbarConfig}
              mode="simple"
              style={{ borderBottom: '1px solid #ccc' }}
            />

            <Editor
              defaultConfig={editorConfig}
              value={html}
              onCreated={handleEditorCreated}
              onChange={handleEditorChange}
              mode="simple"
              style={{ height: '500px', overflowY: 'hidden', width: '100%' }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={handleSubmit} disabled={!html} loading={loading}>
            {formatMessage({ id: 'dbh_studio_funcom_edit_modal_comfirm' })}
          </Button>
          <Button
            type="weak"
            onClick={handelCancel}
          >
            {formatMessage({ id: 'dbh_studio_funcom_edit_modal_cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditModal;